/**
 * @flow
 * @relayHash af304a5b64adee1fd7adaaa95c503eef
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type pdpSharedNotificationTradeMicroGoalConfigQueryVariables = {|
  itemId?: ?string,
  userId?: ?string,
  buyerId?: ?$ReadOnlyArray<?string>,
|};
export type pdpSharedNotificationTradeMicroGoalConfigQueryResponse = {|
  +viewer: ?{|
    +isMicroGoalsDisabled: ?boolean,
    +transactions: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +checkoutDate: ?string
        |}
      |}>
    |},
    +conversationsSolr: ?{|
      +totalResults: ?number
    |},
    +item: ?{|
      +canBuyerMakeOffer: ?boolean,
      +displayInfo: ?{|
        +ctas: ?{|
          +showRequestOnApproval: ?boolean,
          +showHoldRequest: ?boolean,
        |}
      |},
    |},
  |}
|};
export type pdpSharedNotificationTradeMicroGoalConfigQuery = {|
  variables: pdpSharedNotificationTradeMicroGoalConfigQueryVariables,
  response: pdpSharedNotificationTradeMicroGoalConfigQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "buyerId",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "isMicroGoalsDisabled",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableTradeMicroGoalCallouts",
      "type": "String!"
    }
  ],
  "storageKey": "isEnabled(key:\"disableTradeMicroGoalCallouts\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "buyerId",
    "type": "[String]"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1,
    "type": "Int"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "checkoutDate desc",
    "type": "String"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "checkoutDate",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String"
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "conversationsSolr",
  "storageKey": null,
  "args": [
    (v4/*: any*/),
    {
      "kind": "Variable",
      "name": "itemId",
      "variableName": "itemId",
      "type": "String"
    }
  ],
  "concreteType": "ConversationsSolrConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId",
    "type": "String!"
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canBuyerMakeOffer",
  "args": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayInfo",
  "storageKey": null,
  "args": [
    (v4/*: any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "pdp",
      "type": "PageDisplayEnum"
    }
  ],
  "concreteType": "ItemDisplayInfo",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "ctas",
      "storageKey": null,
      "args": null,
      "concreteType": "CTADisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRequestOnApproval",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showHoldRequest",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v6/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v6/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v9/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "id": "app-buyer-finding/213.0.0-2019-04-23T14:40:24.662Z/pdpSharedNotificationTradeMicroGoalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '98f8c5199f8a771ad89a5073e59bdf42';
module.exports = node;
